<template>
	<div class="flex flex-col gap-3">
		<form-search :type="search" @select="selectTarget($event)" :replaceOnSelect="true"></form-search>
		<!-- COMMENT -->
		<form-textarea placeholder="Commentaire" v-model="form.comment" class="col-span-2"> </form-textarea>
		<ui-button @click="$emit('send', form)" :loading="loading">
			<template v-slot:text>Ajouter ce rappel</template>
		</ui-button>
	</div>
</template>

<script setup>
	import { ref } from 'vue';

	const emit = defineEmits(['send']);

	const props = defineProps({
		// What we're searching for as target
		search: {
			type: String,
			default: 'structure',
		},
		loading: {
			type: Boolean,
			default: false,
		},
	});

	const form = ref({
		targetable_type: null,
		targetable_id: null,
		comment: null,
	});

	const selectTarget = (target) => {
		form.value.targetable_type = target.model_type;
		form.value.targetable_id = target.id;
	};
</script>
